var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.filter.title
      ? _c("div", { staticClass: "col-12" }, [
          _c("p", { staticClass: "filter__label group__label" }, [
            _vm._v(_vm._s(_vm.filter.title)),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "filter__group col-12" },
      [
        _vm._l(_vm.filter.options, function (option) {
          return [
            _c(
              "button",
              {
                staticClass: "filter filter--secondary",
                class: [_vm.isActive(option.value)],
                attrs: { disabled: _vm.isActive(option.value) === "inactive" },
                on: {
                  click: function ($event) {
                    _vm.select(
                      option,
                      _vm.isActive(option.value) === "inactive"
                    )
                  },
                },
              },
              [
                option.title
                  ? [
                      _c("span", {
                        domProps: { innerHTML: _vm._s(option.title) },
                      }),
                    ]
                  : [
                      _c("span", {
                        domProps: { innerHTML: _vm._s(option.value) },
                      }),
                    ],
              ],
              2
            ),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }